import { MappedClass, MappedProperty } from '@h5s/util-object';

@MappedClass()
export class RoomAmenity {
  @MappedProperty()
  descriptionDE: string | null;

  @MappedProperty()
  descriptionEN: string | null;

  @MappedProperty()
  descriptionES: string | null;

  @MappedProperty()
  descriptionFR: string | null;

  @MappedProperty()
  descriptionIT: string | null;

  @MappedProperty()
  id: number;
}
